let logId = 0;
let logs = [];
let subscribers = [];

const logger = {
  logs: () => [...logs],
  
  subscribe: (callback) => {
    subscribers.push(callback);
    callback([...logs]);
    
    return () => {
      subscribers = subscribers.filter(sub => sub !== callback);
    };
  },

  log: (level, message, data = {}) => {
    const logEntry = {
      id: ++logId,
      timestamp: new Date().toISOString(),
      level,
      message,
      ...data
    };

    logs.push(logEntry);
    
    // Keep only last 100 logs
    if (logs.length > 100) {
      logs = logs.slice(-100);
    }

    // Notify all subscribers
    subscribers.forEach(callback => callback([...logs]));

    // Console log for development
    if (console[level]) {
      console[level](message, data);
    } else {
      console.log(message, data);
    }

    return logEntry;
  },

  info: (message, data = {}) => logger.log('info', message, data),
  warn: (message, data = {}) => logger.log('warn', message, data),
  error: (message, data = {}) => logger.log('error', message, data),
  success: (message, data = {}) => logger.log('success', message, data),

  logRequest: (api, method, url, requestData) => {
    return logger.log('info', `${method} ${url}`, {
      api,
      method,
      url,
      request: requestData,
      type: 'request'
    });
  },

  logResponse: (logId, status, responseData, duration, headers = {}) => {
    const logIndex = logs.findIndex(log => log.id === logId);
    if (logIndex !== -1) {
      logs[logIndex] = {
        ...logs[logIndex],
        status,
        response: responseData,
        duration,
        headers,
        type: status >= 400 ? 'error' : 'success'
      };
      
      // Notify subscribers
      subscribers.forEach(callback => callback([...logs]));
    }
  },

  logError: (logId, error, status = 0) => {
    const logIndex = logs.findIndex(log => log.id === logId);
    if (logIndex !== -1) {
      logs[logIndex] = {
        ...logs[logIndex],
        error: error.message || error,
        status: status || 500,
        type: 'error'
      };
      
      // Notify subscribers
      subscribers.forEach(callback => callback([...logs]));
    } else {
      // Create new error log if no existing log found
      logger.error('API Error', {
        error: error.message || error,
        status: status || 500
      });
    }
  },

  clear: () => {
    logs = [];
    subscribers.forEach(callback => callback([]));
  }
};

export { logger };